import { addStyles } from 'ethcss'
import { IStyles } from 'theme'

export const styles: IStyles = {}

addStyles(styles)
